<template>
  <div class="wrapper">
    <div v-if="pageContent" class="solar-packages">
      <div class="solar-packages__header">
        <h2 class="h4 solar-packages__title">{{ pageContent.title }}</h2>
        <p class="solar-packages__description">{{ description }}</p>
      </div>
      <Carousel
        :cards="carouselPackages"
        :copy="{}"
        no-padding
        buttons-mobile
        margins="small"
        class="solar-packages__carousel"
        @get-quote="next($event)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapMutations, mapState } from "vuex"
import cmsPreviewMixin from "@soenergy/frontend-library/src/mixins/cmsPreviewMixin"
import Carousel from "@soenergy/frontend-library/src/components/Carousel.vue"
import story from "soenergy-cms-loader!?path=solar/solar-packages"
import { SolarPackages } from "../types/SolarPackages"
import { RootState } from "@/store/untested/types"

// in code rather than CMS (deprecated); also inlined in QuoteSolarPackages.vue
const PACKAGES_DESCRIPTION =
  "In your quote, we will provide a range of tailored options for you to choose from. Please indicate your overall preference to help us guide your recommendation."

// in code rather than CMS (deprecated); also inlined in QuoteSolarPackages.vue
const PACKAGE_IMAGES: Record<string, { filename: string }> = {
  solar_panel_plus_battery: {
    filename: require("@/assets/images/package-solar-plus-battery.svg"),
  },
  solar_panel_only: {
    filename: require("@/assets/images/package-solar-only.svg"),
  },
  battery_only: {
    filename: require("@/assets/images/package-battery-only.svg"),
  },
}

export default defineComponent({
  components: {
    Carousel,
  },
  mixins: [cmsPreviewMixin<SolarPackages>({ story })],
  emits: ["go-forward"],
  computed: {
    ...mapState({
      selectedPackage: (state: RootState) => state.quote.solarPackage,
    }),
    description() {
      return process.env.VUE_APP_ENABLE_QUOTE_RECKONER === "true"
        ? PACKAGES_DESCRIPTION
        : this.pageContent?.description
    },
    carouselPackages() {
      const packages = this.pageContent?.packages
      if (
        process.env.VUE_APP_ENABLE_QUOTE_RECKONER === "true" &&
        Array.isArray(packages)
      ) {
        return packages.map((pkg) => ({
          ...pkg,
          image: PACKAGE_IMAGES[pkg.packageId] ?? pkg.image,
          price: "",
          pricePerMonth: "",
        }))
      }
      return packages
    },
  },
  watch: {
    selectedPackage: {
      handler() {
        this.$emit("go-forward")
      },
    },
  },
  methods: {
    ...mapMutations({
      setSolarPackage: "SET_SOLAR_PACKAGE",
    }),
    next(selectedPackageDetails) {
      // the watcher only fires on change, so a re-pick must advance explicitly
      const unchanged =
        this.selectedPackage === selectedPackageDetails?.packageId
      this.setSolarPackage(selectedPackageDetails)
      if (unchanged) {
        this.$emit("go-forward")
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.solar-packages {
  &__header {
    max-width: $width-7;
  }
  &__description {
    font-size: $font-size-4;
    margin: $space-4 0 $space-2;
  }
  &__article-wrapper {
    max-width: 550px;
  }
  &__carousel {
    padding: 0;
    margin: 0;
  }
}
</style>
